import type { TFunction } from 'i18next';

const TOOL_DISPLAY_KEYS: Record<string, { key: string; fallback: { fr: string; en: string } }> = {
  'get-policies': {
    key: 'conversation.tools.getPolicies',
    fallback: { fr: 'Recherche de polices', en: 'Searching policies' },
  },
  'create-mta': {
    key: 'conversation.tools.createMta',
    fallback: { fr: "Préparation d'un avenant", en: 'Preparing amendment' },
  },
  'navigate-to': {
    key: 'conversation.tools.navigateTo',
    fallback: { fr: 'Navigation', en: 'Navigating' },
  },
};

export function getToolDisplayName(toolName: string, t: TFunction, locale: string = 'fr'): string {
  const entry = TOOL_DISPLAY_KEYS[toolName];
  if (!entry) return toolName;
  const lang = locale.startsWith('en') ? 'en' : 'fr';
  return t(entry.key, { defaultValue: entry.fallback[lang] });
}
